import { writable } from 'svelte/store';

import { createVisibilityStore } from '@shared/libs/tools';

export const artworkPurchaseInfo = createVisibilityStore();

const createPurchasePriceStore = () => {
  const { subscribe, set } = writable(0);

  return {
    subscribe,
    set,
  };
};

export const purchasePrice = createPurchasePriceStore();
